import { render, staticRenderFns } from "./book-appointment.html?vue&type=template&id=ff53b3c0&scoped=true&external"
import script from "./book-appointment.js?vue&type=script&lang=js&external"
export * from "./book-appointment.js?vue&type=script&lang=js&external"
import style0 from "./book-appointment.scss?vue&type=style&index=0&id=ff53b3c0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff53b3c0",
  null
  
)

export default component.exports